import { apiService } from '@/services/APIService';

const URL = 'https://api.pfdo.ru/v2/main-page';

export default {
  getRegions(params) {
    return apiService.get(`${URL}/regions`, params);
  },

  getMuns(region_id, params) {
    return apiService.get(`${URL}/muns/${region_id}`, params);
  },

  getOrganizations(params) {
    return apiService.get(`${URL}/search/organizations`, params);
  },
};
